/* Teeshaa cart (Oct 11): drawer lines + summary, discount code, India delivery estimate. Shared by the drawer and /cart.
   Reads everything from /cart.js; the bands mirror the India shipping rates in Shopify (kg ceiling, ₹). */
(function () {
  var root = document.querySelector('[data-cx-bands]');
  if (!root) return;
  var bands = JSON.parse(root.getAttribute('data-cx-bands') || '[]');
  var free = parseInt(root.getAttribute('data-cx-free') || '0', 10); // paise; 0 = no complimentary-delivery threshold
  var rs = function (p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return [].slice.call((el || document).querySelectorAll(s)); };
  function delivery(c) {
    var kg = c.total_weight / 1000;
    if (!c.item_count || !(kg > 0)) return null;
    if (free && c.total_price >= free) return 0;
    for (var i = 0; i < bands.length; i++) if (kg <= bands[i][0]) return bands[i][1] * 100;
    return null;
  }
  var TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v6M14 11v6"/></svg>';

  // ---------- drawer ----------
  var drawer = $('.nx .js-mini-cart .mini-cart-content');
  var list = drawer && $('.cx-items', drawer);
  function lineHTML(it) {
    var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
    var save = it.original_line_price > it.final_line_price;
    var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
    return '<li class="cx-it" data-key="' + esc(it.key) + '">' +
      '<a class="cx-it__ph" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="240" height="300">' : '') + '</a>' +
      '<div><a class="cx-it__n" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
      (variant ? '<p class="cx-it__v">' + esc(variant) + '</p>' : '<p class="cx-it__v"></p>') +
      '<div class="cx-it__row"><div class="cx-qty"><button type="button" data-q="-1" aria-label="One fewer">&minus;</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-q="1" aria-label="One more">+</button></div>' +
      '<button type="button" class="cx-rm" data-rm aria-label="Remove ' + esc(it.product_title) + '">' + TRASH + '</button></div></div>' +
      '<div class="cx-it__p"><b>' + rs(it.final_line_price) + '</b>' + (save ? '<s>' + rs(it.original_line_price) + '</s><span class="cx-pill">Save ' + rs(it.original_line_price - it.final_line_price) + '</span>' : '<span class="cx-pill cx-pill--ghost">Made to order</span>') + '</div></li>';
  }
  function counts(n) {
    $$('.js-cart-count').forEach(function (el) { el.textContent = /^\s*\(/.test(el.textContent) ? '(' + n + ')' : n; });
  }
  function paint(c) {
    var d = delivery(c);
    if (drawer) {
      drawer.classList.toggle('is-empty', !c.item_count);
      if (list) list.innerHTML = c.items.map(lineHTML).join('');
      var empty = $('.cx-empty', drawer); if (empty) empty.hidden = !!c.item_count;
      counts(c.item_count);
    }
    // meter, rows and checkout label exist in both contexts
    $$('[data-cx-meter]').forEach(function (m) {
      m.hidden = d === null && !free;
      var t = $('.cx-meter__txt', m), bar = $('.cx-meter__bar', m);
      if (free && c.total_price < free) {
        t.innerHTML = 'Add <b>' + rs(free - c.total_price) + '</b> for complimentary delivery in India';
      } else if (d === 0) {
        t.innerHTML = '<b>Complimentary delivery</b> in India';
      } else if (d !== null) {
        t.innerHTML = 'Delivery in India <b>' + rs(d) + '</b> · international rates at checkout';
      }
      if (bar) { bar.hidden = !free; $('i', bar).style.transform = 'scaleX(' + (free ? Math.min(1, c.total_price / free) : 0) + ')'; }
    });
    $$('[data-cx-ship]').forEach(function (r) { r.hidden = d === null; if (d !== null) $('dd', r).textContent = d === 0 ? 'Complimentary' : rs(d); });
    $$('[data-cx-save]').forEach(function (r) { r.hidden = !(c.total_discount > 0); if (c.total_discount > 0) $('dd', r).textContent = '−' + rs(c.total_discount); });
    $$('[data-cx-sub]').forEach(function (el) { el.textContent = rs(c.total_price); });
    $$('.cx-go__t').forEach(function (el) { el.textContent = c.item_count ? rs(c.total_price) : ''; });
    $$('.cx-go').forEach(function (b) { b.disabled = !c.item_count; });
  }
  var req = 0;
  function refresh() {
    var n = ++req;
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { if (n === req) paint(c); return c; }).catch(function () {});
  }
  function change(key, qty) {
    if (list) list.classList.add('cx-busy');
    return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (c) { paint(c); }).catch(refresh)
      .then(function () { if (list) list.classList.remove('cx-busy'); });
  }
  if (list) list.addEventListener('click', function (e) {
    var li = e.target.closest('.cx-it'); if (!li) return;
    var q = e.target.closest('[data-q]'), rm = e.target.closest('[data-rm]');
    var cur = parseInt($('.cx-qty span', li).textContent, 10) || 0;
    if (q) change(li.getAttribute('data-key'), Math.max(0, cur + parseInt(q.getAttribute('data-q'), 10)));
    if (rm) change(li.getAttribute('data-key'), 0);
  });
  if (drawer) {
    // the theme re-fills its own list after add-to-cart and toggles .active when the drawer opens: repaint ours then
    var t, later = function () { clearTimeout(t); t = setTimeout(refresh, 120); };
    var theirs = $('.js-mini-cart-content', drawer);
    if (theirs) new MutationObserver(later).observe(theirs, { childList: true, subtree: true });
    var host = drawer.closest('.js-mini-cart');
    if (host) new MutationObserver(function () { if (host.classList.contains('active')) later(); }).observe(host, { attributes: true, attributeFilter: ['class'] });
  }

  // ---------- discount code ----------
  $$('[data-cx-code]').forEach(function (box) {
    var input = $('input', box), btn = $('button', box), msg = box.parentNode.querySelector('.cx-code-msg');
    function apply(e) {
      if (e) e.preventDefault();
      var code = input.value.trim();
      if (!code) return;
      msg.className = 'cx-code-msg'; msg.textContent = 'Checking…';
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).then(refresh).then(function (c) {
        if (!c) throw 0;
        var hit = (c.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code.toUpperCase(); })[0];
        if (hit && hit.applicable === false) { msg.textContent = 'This code isn’t valid for the pieces in your cart.'; return; }
        if (hit || c.total_discount > 0) {
          msg.className = 'cx-code-msg is-ok'; msg.textContent = 'Code applied.';
          if (box.hasAttribute('data-cx-reload')) setTimeout(function () { location.reload(); }, 500);
          return;
        }
        msg.textContent = 'Code saved. It will be applied at checkout.';
      }).catch(function () { msg.textContent = 'Couldn’t check the code. You can also enter it at checkout.'; });
    }
    // the drawer's box is its own form; the cart page's is a div inside the cart form (Enter must not submit the cart)
    if (box.tagName === 'FORM') box.addEventListener('submit', apply);
    else { btn.addEventListener('click', apply); input.addEventListener('keydown', function (e) { if (e.key === 'Enter') apply(e); }); }
  });

  refresh();
})();
